<template>
  <section>
    <Card>
      <div class="feedback comp-card">
        <div class="card-detail-body">
          <div v-if="!submitted" class="form">
            <h3 class="header heading">
              Give feedback to Feedback Loop. Are these insights helpful?
            </h3>        <div class="rate">
              <div class="buttons">
                <button class="rate-button" :class="{ active: rating === Rating.Good }" @click="upVote">
                  <Icon name="thumb_up" />
                  Yes
                </button>
                <button class="rate-button" :class="{ active: rating === Rating.Bad }" @click="downVote">
                  <Icon name="thumb_down" />
                  No
                </button>
              </div>
              <button v-if="rating !== Rating.None" class="clear-button" @click="clear">
                <Icon name="clear" />
              </button>
            </div>
            <div v-if="rating !== Rating.None" class="feedback-text">
              <div class="feedback-text-label">
                <template v-if="rating === Rating.Good">
                  Great! What in particular was helpful and why?
                </template>
                <template v-if="rating === Rating.Bad">
                  Do you have any feedback on how we could improve?
                </template>
              </div>
              <textarea v-model="text" rows="4" @input="textInput"></textarea>
              <div class="character-count" :class="{ error: text.length > maxTextLength }">
                {{ text.length }}/{{ maxTextLength }}
              </div>
              <div class="submit">
                <AjaxButton text="Submit Feedback" classes="btn-primary" :disabled="text.length > maxTextLength" @click="submit" />
              </div>
            </div>
          </div>
          <div v-else class="confirmation">
            <h3 class="header">
              Feedback successfully submitted.
              <Icon name="check_circle_outline" classes="submitted-check" />
            </h3>
            <p>Thanks! Your feedback will be used to improve our testing, insights, and product.</p>
          </div>
        </div>
      </div>
    </Card>
  </section>
</template>

<script>
import { Icon, Card } from '@alpha/ink'
import AjaxButton from '@/components/AjaxButton.vue'

import api from '@/api'
import analytics from '@/analytics'
import { Rating } from '@shared/types/database'

export default {
  components: {
    Icon,
    AjaxButton,
    Card
  },
  props: {
    workspaceId: {
      type: String,
      required: true
    },
    testId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      rating: Rating.None,
      text: '',
      submitted: false,
      sentTextAnalytics: false
    }
  },
  computed: {
    Rating () {
      return Rating
    },
    maxTextLength () {
      return 300
    }
  },
  methods: {
    upVote () {
      this.rating = Rating.Good
      this.recordAnalyticsEvent('Feedback Rating Clicked', {
        rating: this.rating
      })
    },
    downVote () {
      this.rating = Rating.Bad
      this.recordAnalyticsEvent('Feedback Rating Clicked', {
        rating: this.rating
      })
    },
    textInput () {
      if (!this.sentTextAnalytics) {
        this.recordAnalyticsEvent('Feedback Text Entered')
        this.sentTextAnalytics = true
      }
    },
    clear () {
      this.rating = Rating.None
      this.text = ''
    },
    submit (receiver) {
      // const url = `/${this.workspaceId}/${this.testId}/feedback`
      const { workspaceId, testId, rating, text } = this
      api.sendFeedback(rating, text, { workspaceId, testId })
        .then(() => {
          this.submitted = true
          this.recordAnalyticsEvent('Feedback Submitted', {
            rating: this.rating,
            text: this.text
          })
        })
        .catch((err) => {
          alert('Sorry, we had an issue saving your feedback.')
          console.error(err)
        })
        .finally(() => {
          receiver.finish()
        })
    },
    recordAnalyticsEvent (eventName) {
      analytics.track(eventName, {
        testId: this.testId,
        workspaceId: this.workspaceId
      })
    }
  }
}
</script>

<style scoped>
  .header {
    margin-bottom: 30px;
    margin-top: 15px;
  }

  .form .header {
    text-align: center;
  }

  .rate {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    position: relative;
  }

  .rate button {
    background: transparent;
    border: 0;
    font-size: 24px;
    cursor: pointer;
  }

  .rate-button {
    margin-right: 10px;
    font-size: 24px;
  }

  .rate-button.active {
    color: $bg-secondary;
  }

  .rate-button:last-child {
    margin: 0;
  }

  .clear-button {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
  }

  .feedback-text textarea {
    width: 100%;
    border: 1px solid #ccc;
    resize: none;
    padding: 5px 8px;
  }

  .character-count {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
  }

  .submit {
    display: flex;
    justify-content: flex-end;
  }

  .feedback-text-label {
    margin-bottom: 15px;
  }

  .feedback-text-label,
  .character-count {
    font-size: 16px;
  }

  .feedback {
    padding: 2rem;
  }

  .confirmation p {
    font-size: 16px;
  }
</style>
